import TimelineConnector from '@material-ui/lab/TimelineConnector';

export default TimelineConnector;
